package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings4 {
  internal val interesting_fact7: StringResource by lazy { init_interesting_fact7() }

  internal val interesting_fact8: StringResource by lazy { init_interesting_fact8() }

  internal val interesting_fact9: StringResource by lazy { init_interesting_fact9() }

  internal val interesting_facts: StringResource by lazy { init_interesting_facts() }

  internal val internet_is_required: StringResource by lazy { init_internet_is_required() }

  internal val invalid_url: StringResource by lazy { init_invalid_url() }

  internal val iyov: StringResource by lazy { init_iyov() }

  internal val key: StringResource by lazy { init_key() }

  internal val label_no: StringResource by lazy { init_label_no() }

  internal val lang_iw: StringResource by lazy { init_lang_iw() }

  internal val last_updated: StringResource by lazy { init_last_updated() }

  internal val last_updated_format: StringResource by lazy { init_last_updated_format() }

  internal val later: StringResource by lazy { init_later() }

  internal val lefi_hamikud: StringResource by lazy { init_lefi_hamikud() }

  internal val lefi_mikud: StringResource by lazy { init_lefi_mikud() }

  internal val left_arrow: StringResource by lazy { init_left_arrow() }

  internal val lexicographical_sort_choose_book_and_chapter: StringResource by lazy {
      init_lexicographical_sort_choose_book_and_chapter() }

  internal val lexicographical_sort_email_pdf: StringResource by lazy {
      init_lexicographical_sort_email_pdf() }

  internal val lexicographical_sort_generate_table: StringResource by lazy {
      init_lexicographical_sort_generate_table() }

  internal val lexicographical_sort_premium_required: StringResource by lazy {
      init_lexicographical_sort_premium_required() }

  internal val lexicographical_sort_preview_title: StringResource by lazy {
      init_lexicographical_sort_preview_title() }

  internal val lexicographical_sort_save_pdf: StringResource by lazy {
      init_lexicographical_sort_save_pdf() }

  internal val lexicographical_sort_verses_in_table: StringResource by lazy {
      init_lexicographical_sort_verses_in_table() }

  internal val lexicographical_sort_view_pdf: StringResource by lazy {
      init_lexicographical_sort_view_pdf() }

  internal val lexicographically: StringResource by lazy { init_lexicographically() }

  internal val lexicographically_sorted_verses_book: StringResource by lazy {
      init_lexicographically_sorted_verses_book() }

  internal val lexicographically_sorted_verses_by_mikud: StringResource by lazy {
      init_lexicographically_sorted_verses_by_mikud() }

  internal val lexicographically_sorted_verses_chapter: StringResource by lazy {
      init_lexicographically_sorted_verses_chapter() }

  internal val lexicographically_sorting_book: StringResource by lazy {
      init_lexicographically_sorting_book() }

  internal val lexicographically_sorting_by_mikud: StringResource by lazy {
      init_lexicographically_sorting_by_mikud() }

  internal val lexicographically_sorting_chapter: StringResource by lazy {
      init_lexicographically_sorting_chapter() }

  internal val listing: StringResource by lazy { init_listing() }

  internal val load_custom_mikud: StringResource by lazy { init_load_custom_mikud() }

  internal val load_onqelos_failed: StringResource by lazy { init_load_onqelos_failed() }

  internal val load_saved_completions: StringResource by lazy { init_load_saved_completions() }

  internal val loading_list: StringResource by lazy { init_loading_list() }

  internal val loading_mikud: StringResource by lazy { init_loading_mikud() }

  internal val map: StringResource by lazy { init_map() }

  internal val material: StringResource by lazy { init_material() }

  internal val max_size: StringResource by lazy { init_max_size() }

  internal val menu: StringResource by lazy { init_menu() }

  internal val menu_refresh: StringResource by lazy { init_menu_refresh() }

  internal val message: StringResource by lazy { init_message() }

  internal val mikud: StringResource by lazy { init_mikud() }

  internal val mikud_loaded_for: StringResource by lazy { init_mikud_loaded_for() }

  internal val mikud_loading: StringResource by lazy { init_mikud_loading() }

  internal val mikud_save: StringResource by lazy { init_mikud_save() }

  internal val mikud_saved: StringResource by lazy { init_mikud_saved() }

  internal val min_size: StringResource by lazy { init_min_size() }

  internal val misc: StringResource by lazy { init_misc() }

  internal fun values(): List<StringResource> = listOf(interesting_fact7, interesting_fact8,
      interesting_fact9, interesting_facts, internet_is_required, invalid_url, iyov, key, label_no,
      lang_iw, last_updated, last_updated_format, later, lefi_hamikud, lefi_mikud, left_arrow,
      lexicographical_sort_choose_book_and_chapter, lexicographical_sort_email_pdf,
      lexicographical_sort_generate_table, lexicographical_sort_premium_required,
      lexicographical_sort_preview_title, lexicographical_sort_save_pdf,
      lexicographical_sort_verses_in_table, lexicographical_sort_view_pdf, lexicographically,
      lexicographically_sorted_verses_book, lexicographically_sorted_verses_by_mikud,
      lexicographically_sorted_verses_chapter, lexicographically_sorting_book,
      lexicographically_sorting_by_mikud, lexicographically_sorting_chapter, listing,
      load_custom_mikud, load_onqelos_failed, load_saved_completions, loading_list, loading_mikud,
      map, material, max_size, menu, menu_refresh, message, mikud, mikud_loaded_for, mikud_loading,
      mikud_save, mikud_saved, min_size, misc)
}

private fun init_interesting_fact7(): StringResource = StringResource(key = "interesting_fact7",
    loader = stringsLoader)

private fun init_interesting_fact8(): StringResource = StringResource(key = "interesting_fact8",
    loader = stringsLoader)

private fun init_interesting_fact9(): StringResource = StringResource(key = "interesting_fact9",
    loader = stringsLoader)

private fun init_interesting_facts(): StringResource = StringResource(key = "interesting_facts",
    loader = stringsLoader)

private fun init_internet_is_required(): StringResource = StringResource(key =
    "internet_is_required", loader = stringsLoader)

private fun init_invalid_url(): StringResource = StringResource(key = "invalid_url", loader =
    stringsLoader)

private fun init_iyov(): StringResource = StringResource(key = "iyov", loader = stringsLoader)

private fun init_key(): StringResource = StringResource(key = "key", loader = stringsLoader)

private fun init_label_no(): StringResource = StringResource(key = "label_no", loader =
    stringsLoader)

private fun init_lang_iw(): StringResource = StringResource(key = "lang_iw", loader = stringsLoader)

private fun init_last_updated(): StringResource = StringResource(key = "last_updated", loader =
    stringsLoader)

private fun init_last_updated_format(): StringResource = StringResource(key = "last_updated_format",
    loader = stringsLoader)

private fun init_later(): StringResource = StringResource(key = "later", loader = stringsLoader)

private fun init_lefi_hamikud(): StringResource = StringResource(key = "lefi_hamikud", loader =
    stringsLoader)

private fun init_lefi_mikud(): StringResource = StringResource(key = "lefi_mikud", loader =
    stringsLoader)

private fun init_left_arrow(): StringResource = StringResource(key = "left_arrow", loader =
    stringsLoader)

private fun init_lexicographical_sort_choose_book_and_chapter(): StringResource = StringResource(key
    = "lexicographical_sort_choose_book_and_chapter", loader = stringsLoader)

private fun init_lexicographical_sort_email_pdf(): StringResource = StringResource(key =
    "lexicographical_sort_email_pdf", loader = stringsLoader)

private fun init_lexicographical_sort_generate_table(): StringResource = StringResource(key =
    "lexicographical_sort_generate_table", loader = stringsLoader)

private fun init_lexicographical_sort_premium_required(): StringResource = StringResource(key =
    "lexicographical_sort_premium_required", loader = stringsLoader)

private fun init_lexicographical_sort_preview_title(): StringResource = StringResource(key =
    "lexicographical_sort_preview_title", loader = stringsLoader)

private fun init_lexicographical_sort_save_pdf(): StringResource = StringResource(key =
    "lexicographical_sort_save_pdf", loader = stringsLoader)

private fun init_lexicographical_sort_verses_in_table(): StringResource = StringResource(key =
    "lexicographical_sort_verses_in_table", loader = stringsLoader)

private fun init_lexicographical_sort_view_pdf(): StringResource = StringResource(key =
    "lexicographical_sort_view_pdf", loader = stringsLoader)

private fun init_lexicographically(): StringResource = StringResource(key = "lexicographically",
    loader = stringsLoader)

private fun init_lexicographically_sorted_verses_book(): StringResource = StringResource(key =
    "lexicographically_sorted_verses_book", loader = stringsLoader)

private fun init_lexicographically_sorted_verses_by_mikud(): StringResource = StringResource(key =
    "lexicographically_sorted_verses_by_mikud", loader = stringsLoader)

private fun init_lexicographically_sorted_verses_chapter(): StringResource = StringResource(key =
    "lexicographically_sorted_verses_chapter", loader = stringsLoader)

private fun init_lexicographically_sorting_book(): StringResource = StringResource(key =
    "lexicographically_sorting_book", loader = stringsLoader)

private fun init_lexicographically_sorting_by_mikud(): StringResource = StringResource(key =
    "lexicographically_sorting_by_mikud", loader = stringsLoader)

private fun init_lexicographically_sorting_chapter(): StringResource = StringResource(key =
    "lexicographically_sorting_chapter", loader = stringsLoader)

private fun init_listing(): StringResource = StringResource(key = "listing", loader = stringsLoader)

private fun init_load_custom_mikud(): StringResource = StringResource(key = "load_custom_mikud",
    loader = stringsLoader)

private fun init_load_onqelos_failed(): StringResource = StringResource(key = "load_onqelos_failed",
    loader = stringsLoader)

private fun init_load_saved_completions(): StringResource = StringResource(key =
    "load_saved_completions", loader = stringsLoader)

private fun init_loading_list(): StringResource = StringResource(key = "loading_list", loader =
    stringsLoader)

private fun init_loading_mikud(): StringResource = StringResource(key = "loading_mikud", loader =
    stringsLoader)

private fun init_map(): StringResource = StringResource(key = "map", loader = stringsLoader)

private fun init_material(): StringResource = StringResource(key = "material", loader =
    stringsLoader)

private fun init_max_size(): StringResource = StringResource(key = "max_size", loader =
    stringsLoader)

private fun init_menu(): StringResource = StringResource(key = "menu", loader = stringsLoader)

private fun init_menu_refresh(): StringResource = StringResource(key = "menu_refresh", loader =
    stringsLoader)

private fun init_message(): StringResource = StringResource(key = "message", loader = stringsLoader)

private fun init_mikud(): StringResource = StringResource(key = "mikud", loader = stringsLoader)

private fun init_mikud_loaded_for(): StringResource = StringResource(key = "mikud_loaded_for",
    loader = stringsLoader)

private fun init_mikud_loading(): StringResource = StringResource(key = "mikud_loading", loader =
    stringsLoader)

private fun init_mikud_save(): StringResource = StringResource(key = "mikud_save", loader =
    stringsLoader)

private fun init_mikud_saved(): StringResource = StringResource(key = "mikud_saved", loader =
    stringsLoader)

private fun init_min_size(): StringResource = StringResource(key = "min_size", loader =
    stringsLoader)

private fun init_misc(): StringResource = StringResource(key = "misc", loader = stringsLoader)

public actual val SharedRes.strings.interesting_fact7: StringResource
  get() = CommonMainStrings4.interesting_fact7

public actual val SharedRes.strings.interesting_fact8: StringResource
  get() = CommonMainStrings4.interesting_fact8

public actual val SharedRes.strings.interesting_fact9: StringResource
  get() = CommonMainStrings4.interesting_fact9

public actual val SharedRes.strings.interesting_facts: StringResource
  get() = CommonMainStrings4.interesting_facts

public actual val SharedRes.strings.internet_is_required: StringResource
  get() = CommonMainStrings4.internet_is_required

public actual val SharedRes.strings.invalid_url: StringResource
  get() = CommonMainStrings4.invalid_url

public actual val SharedRes.strings.iyov: StringResource
  get() = CommonMainStrings4.iyov

public actual val SharedRes.strings.key: StringResource
  get() = CommonMainStrings4.key

public actual val SharedRes.strings.label_no: StringResource
  get() = CommonMainStrings4.label_no

public actual val SharedRes.strings.lang_iw: StringResource
  get() = CommonMainStrings4.lang_iw

public actual val SharedRes.strings.last_updated: StringResource
  get() = CommonMainStrings4.last_updated

public actual val SharedRes.strings.last_updated_format: StringResource
  get() = CommonMainStrings4.last_updated_format

public actual val SharedRes.strings.later: StringResource
  get() = CommonMainStrings4.later

public actual val SharedRes.strings.lefi_hamikud: StringResource
  get() = CommonMainStrings4.lefi_hamikud

public actual val SharedRes.strings.lefi_mikud: StringResource
  get() = CommonMainStrings4.lefi_mikud

public actual val SharedRes.strings.left_arrow: StringResource
  get() = CommonMainStrings4.left_arrow

public actual val SharedRes.strings.lexicographical_sort_choose_book_and_chapter: StringResource
  get() = CommonMainStrings4.lexicographical_sort_choose_book_and_chapter

public actual val SharedRes.strings.lexicographical_sort_email_pdf: StringResource
  get() = CommonMainStrings4.lexicographical_sort_email_pdf

public actual val SharedRes.strings.lexicographical_sort_generate_table: StringResource
  get() = CommonMainStrings4.lexicographical_sort_generate_table

public actual val SharedRes.strings.lexicographical_sort_premium_required: StringResource
  get() = CommonMainStrings4.lexicographical_sort_premium_required

public actual val SharedRes.strings.lexicographical_sort_preview_title: StringResource
  get() = CommonMainStrings4.lexicographical_sort_preview_title

public actual val SharedRes.strings.lexicographical_sort_save_pdf: StringResource
  get() = CommonMainStrings4.lexicographical_sort_save_pdf

public actual val SharedRes.strings.lexicographical_sort_verses_in_table: StringResource
  get() = CommonMainStrings4.lexicographical_sort_verses_in_table

public actual val SharedRes.strings.lexicographical_sort_view_pdf: StringResource
  get() = CommonMainStrings4.lexicographical_sort_view_pdf

public actual val SharedRes.strings.lexicographically: StringResource
  get() = CommonMainStrings4.lexicographically

public actual val SharedRes.strings.lexicographically_sorted_verses_book: StringResource
  get() = CommonMainStrings4.lexicographically_sorted_verses_book

public actual val SharedRes.strings.lexicographically_sorted_verses_by_mikud: StringResource
  get() = CommonMainStrings4.lexicographically_sorted_verses_by_mikud

public actual val SharedRes.strings.lexicographically_sorted_verses_chapter: StringResource
  get() = CommonMainStrings4.lexicographically_sorted_verses_chapter

public actual val SharedRes.strings.lexicographically_sorting_book: StringResource
  get() = CommonMainStrings4.lexicographically_sorting_book

public actual val SharedRes.strings.lexicographically_sorting_by_mikud: StringResource
  get() = CommonMainStrings4.lexicographically_sorting_by_mikud

public actual val SharedRes.strings.lexicographically_sorting_chapter: StringResource
  get() = CommonMainStrings4.lexicographically_sorting_chapter

public actual val SharedRes.strings.listing: StringResource
  get() = CommonMainStrings4.listing

public actual val SharedRes.strings.load_custom_mikud: StringResource
  get() = CommonMainStrings4.load_custom_mikud

public actual val SharedRes.strings.load_onqelos_failed: StringResource
  get() = CommonMainStrings4.load_onqelos_failed

public actual val SharedRes.strings.load_saved_completions: StringResource
  get() = CommonMainStrings4.load_saved_completions

public actual val SharedRes.strings.loading_list: StringResource
  get() = CommonMainStrings4.loading_list

public actual val SharedRes.strings.loading_mikud: StringResource
  get() = CommonMainStrings4.loading_mikud

public actual val SharedRes.strings.map: StringResource
  get() = CommonMainStrings4.map

public actual val SharedRes.strings.material: StringResource
  get() = CommonMainStrings4.material

public actual val SharedRes.strings.max_size: StringResource
  get() = CommonMainStrings4.max_size

public actual val SharedRes.strings.menu: StringResource
  get() = CommonMainStrings4.menu

public actual val SharedRes.strings.menu_refresh: StringResource
  get() = CommonMainStrings4.menu_refresh

public actual val SharedRes.strings.message: StringResource
  get() = CommonMainStrings4.message

public actual val SharedRes.strings.mikud: StringResource
  get() = CommonMainStrings4.mikud

public actual val SharedRes.strings.mikud_loaded_for: StringResource
  get() = CommonMainStrings4.mikud_loaded_for

public actual val SharedRes.strings.mikud_loading: StringResource
  get() = CommonMainStrings4.mikud_loading

public actual val SharedRes.strings.mikud_save: StringResource
  get() = CommonMainStrings4.mikud_save

public actual val SharedRes.strings.mikud_saved: StringResource
  get() = CommonMainStrings4.mikud_saved

public actual val SharedRes.strings.min_size: StringResource
  get() = CommonMainStrings4.min_size

public actual val SharedRes.strings.misc: StringResource
  get() = CommonMainStrings4.misc
